export class State {
  error: Record<string, any> = {};
  success: Record<string, any> = {};
  isLoading = false;
  dataItem: Record<string, any> = {};
  isConsumerView = false;
  logo = null;
  appVersion = null;
  lastUserActionTimestamp = -1;
}
